import { RefreshAvatarIconButtonProps } from 'components/SecretIdentity/Types'
import { ArrowRefresh } from 'blaze-ui/icons'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useSelectAvatarButton } from './useSelectAvatarButton'
import { forwardRef } from 'react'
import { mergeProps } from '@react-aria/utils'

export const RefreshAvatarIconButton = forwardRef<HTMLButtonElement, RefreshAvatarIconButtonProps>(
  ({ icon = ArrowRefresh, ...rest }, fRef) => {
    const { buttonProps } = useSelectAvatarButton(rest)

    return <IconButton aria-label="Select Avatar" icon={icon} {...mergeProps(rest, buttonProps)} ref={fRef} />
  },
)
